import {
  BASE_CORE_URL,
  BASE_URL,
  UAPI_URL_AUTH,
  UAPI_URL_CONFIG,
  UAPI_URL_NOTIFICATION
} from "./../config/index";

//#region Api calling for Login the application
export const loginDotNet = async (email, password) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      email: email,
      password: password,
      module: "Web",
      ipAddress: "string",
      identifier:"Web"
    }),
  };
  const url = UAPI_URL_AUTH + "Login";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then((data) => {
      return data;
    })
    .catch(function (error) {
      console.error("Login Error", { error });
    });
};
//#endregion

//#region new FastApi of Logout the application
// export const Logout = async (userObj) => {
//   const requestOptions = {
//     method: " POST",
//     headers: {
//       "Content-Type": "application/json",
//       "authcode": localStorage.getItem('authCode'),
//       "Authorization": "Bearer " + localStorage.getItem('authToken')
//     },
//     body: JSON.stringify(userObj)
//   }
//   let url = UAPI_URL_AUTH + "Logout?" + new URLSearchParams({
//     authCode: localStorage.getItem('authCode')
//   });
//   return await fetch(url, requestOptions)
//     .then((resp) => resp.json())
//     .then((data) => {
//       return data;
//     })
//     .catch(function (error) {
//       console.error("Logout Error", {error});

//     })
// }
//#endregion

//#region old Api of Login the application
export const loginCF = async (email, fcm, datetime) => {
  // Simple POST request with a JSON body using fetch

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      Email: email,
      UPassword: null,
      FCMToken: fcm,
      DeviceID: null,
      ComponentType: "Web",
      datetime: datetime,
    }),
  };
return null;
  const url = BASE_URL + "login";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("Login Error", { error });
    });
};
//#endregion

//#region old API register the user
export const RegisterUser = async (obj) => {
  // Simple POST request with a JSON body using fetch
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(obj),
  };
  return null;
  const url = BASE_URL + "registration";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error(error);
    });
};
//#endregion

//#region  Api calling for Logout the application
export const LogoutDotNet = async (userObj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(userObj),
  };
  let url =
    UAPI_URL_AUTH +
    "Logout?" +
    new URLSearchParams({
      authCode: localStorage.getItem("authCode"),
    });
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then((data) => {
      return data;
    })
    .catch(function (error) {
      console.error("Logout Error", { error });
    });
};
//#endregion

//#region old Api of Logout the application
export const LogoutUser = async (UserUniqueId) => {
  // Simple POST request with a JSON body using fetch
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      UserUniqueID: UserUniqueId,
    }),
  };
return null;
  const url = BASE_URL + "logout";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      localStorage.removeItem("user");
      return data;
    })
    .catch(function (error) {
      console.error("Login Error", { error });
    });
};
//#endregion

//#region api calling for change password
export const changePassword = async (
  user_id,
  old_password,
  new_password,
  email
) => {
  let requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      email: email,
      oldPassword: old_password,
      newPassword: new_password,
    }),
  };
  let url = UAPI_URL_AUTH + "ChangePassword";

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then((data) => {
      return data;
    })
    .catch(function (error) {
      console.error("Login Error", { error });
    });
};
//#endregion

//#region Api calling for updateFCMDetails
// export const updateFCMDetails = async (userId, fcmToken, datetime) => {
//   const requestOptions = {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({
//       UserId: userId,
//       Token: fcmToken,
//       DateTime: datetime,
//       ComponentType: "Web"
//     }),
//   }
//   console.log('Firebase Login', requestOptions)
//   let componentType = "Web"
//   const url = BASE_URL + "updatefcmdetails";
//   // const url = UAPI_URL_CONFIG + "fcmToken/getById" + `?FCMTokenId=${fcmToken}&UserId=${userId}&ComponentType=${componentType}`;
//   return await fetch(url, requestOptions)
//     .then((res) => res.json())
//     .then((data) => {
//       console.log('Firebase Login', data)
//       return data;
//     })
//     .catch((err) => {
//       console.error("Update FCM Details", err);
//     })
// }

export const getDetailsById = async (userid, ComponentType) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  const url =
    UAPI_URL_CONFIG +
    "fcmToken/getById" +
    `?UserId=${userid}&ComponentType=${ComponentType}`;

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("Get Error", { error });
    });
};

export const addFCMDetails = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  const url = UAPI_URL_CONFIG + "fcmToken/add/";
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.error("Add fcm error", err);
    });
};

export const updateFCMDetails = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let componentType = "Web";
  const url = UAPI_URL_CONFIG + "fcmToken/update/";
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.error("Update FCM Details error", err);
    });
};
//#endregion

//#region Api calling for reset password
export const resetPassword = async (para) => {
  let requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url =
    UAPI_URL_AUTH +
    "ResetPassword?" +
    new URLSearchParams({
      info: para,
    });

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then((data) => {
      return data;
    })
    .catch(function (error) {
      console.error("Reset Password Error", { error });
    });
};
//#endregion

//#region Api Calling for update firebase user
export const updateFirebaseUser = async (email, password) => {
  let requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Email: email,
      NewPassword: password,
    }),
  };
return null;
  let url = BASE_URL + "firebasepasswordchange";
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region api calling for verification link
export const verificationLink = async (email) => {
  const requestOptions = {
    method: "GET",
    "Content-Type": "application/json",
    authcode: localStorage.getItem("authCode"),
    Authorization: "Bearer " + localStorage.getItem("authToken"),
  };
  let url = UAPI_URL_AUTH + `GenerateVerificationLink?emailId=` + email;
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => console.log(err));
};
//#endregion

//#region Api calling for setting theme
// export const backgroundThemeFunction = async(userId,darkThemeNumber, obj)=>{
export const backgroundThemeFunction = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_AUTH + "Update";

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => console.log(err));
};
//#endregion

//#region Api calling for setting theme
export const userSoundMode = async (userId, status) => {
  const requestOptions = {
    method: "GET",
    "Content-Type": "application/json",
    authcode: localStorage.getItem("authCode"),
    Authorization: "Bearer " + localStorage.getItem("authToken"),
  };
  let url =
    BASE_CORE_URL + `User/SetSoundMode?pUserId=${userId}&pMode=${status}`;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => console.log(err));
};
//#endregion

//#region Api calling for notification
export const GetNotification = async (userUniqueId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  // let url = BASE_CORE_URL + "Notification/GetNotifications?userUniqueId="+ userUniqueId;
  let url = UAPI_URL_NOTIFICATION + "getNotification?userId=" + userUniqueId;
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => console.log(err));
};
export const GetNotificationRead = async (userUniqueId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  // let url =
    // BASE_CORE_URL + "Notification/UpdateNotifications?id=" + userUniqueId;
    let url = UAPI_URL_NOTIFICATION +"updateNotification?Id=" + userUniqueId;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => console.log(err));
};
//#endregion

export const clearAllNotifications = async (userUniqueId) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url = UAPI_URL_NOTIFICATION + "clearNotification?UserID=" + userUniqueId;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => console.log(err));
};